import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

// Interface

export interface IPromotionPriceRangeParams {
  couponCodes: string[]
  skuList: {
    quantity: number
    skuId: number
    roomId: string
  }[]
}
export interface IPromotionPriceRangeResponse {
  minPrice: number
  maxPrice: number
}

class fetchPromotionPriceRangeApi extends Service {
  constructor(params: IPromotionPriceRangeParams) {
    super()
    this.name = 'FETCH_PROMOTION_PRICE_TANGE'

    this.config = {
      url: `/v1/product/promotion/price/range`,
      method: 'POST',
      data: { ...params },
    }
  }
}

export const fetchPromotionPriceRange = (params: IPromotionPriceRangeParams): IPromotionPriceRangeParams =>
  getCallApiFunction(new fetchPromotionPriceRangeApi(params))
